import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {LazyLoadImageModule} from 'ng-lazyload-image';
import {AuthenticationModule} from '../../Authentication/authentication-module/authentication.module';
import {LoginComponent} from '../../Authentication/components/login/login.component';

import {
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    GameGridComponent,
    LoadingComponent,
    GameComponent,
    MgWalletComponent,
} from '../components';

import {ClickOutsideDirective, ImagePreloadDirective} from '../directives';

import {
    GameService,
    LocalStorageService,
    CustomHttpService,
    ModalService,
    DomService,
    LoaderService,
    EventService,
    NotificationService,
    GroupService,
    BrandService,
    PasswordService,
    GamehistoryService,
    LocalService,
    GeneralBehaviorSubjectService,
} from '../services';

import {FilterPipe} from '../pipes';
import {TranslateModule} from '@ngx-translate/core';
import {AccountStatusInterceptor} from '@Shared/interceptors/account-status-interceptor';
import {Ng2OdometerModule} from 'ng2-odometer';
import {JackpotService} from '@myServices/jackpot.service';
import {JackpotsHeaderComponent} from '@Shared/components/jackpots-header/jackpots-header.component';
import {NguCarouselModule} from "@ngu/carousel";
import {MostPlayedComponent} from "@Shared/components/most-played";


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        LazyLoadImageModule,
        AuthenticationModule,
        TranslateModule,
        Ng2OdometerModule,
        NguCarouselModule,
    ],
    declarations: [
        HeaderComponent,
        FooterComponent,
        SidebarComponent,
        ClickOutsideDirective,
        ImagePreloadDirective,
        GameGridComponent,
        LoadingComponent,
        GameComponent,
        FilterPipe,
        MgWalletComponent,
        JackpotsHeaderComponent,
        MostPlayedComponent,
    ],
    providers: [
        GameService,
        LocalStorageService,
        CustomHttpService,
        // ModalService,
        DomService,
        EventService,
        NotificationService,
        LoaderService,
        GroupService,
        BrandService,
        PasswordService,
        GamehistoryService,
        LocalService,
        GeneralBehaviorSubjectService,
        {provide: HTTP_INTERCEPTORS, useClass: AccountStatusInterceptor, multi: true},
        JackpotService,

    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        SidebarComponent,
        ClickOutsideDirective,
        ImagePreloadDirective,
        GameGridComponent,
        LoadingComponent,
        MgWalletComponent,
        GameComponent,
        JackpotsHeaderComponent,
        MostPlayedComponent,
    ],
    entryComponents: [LoginComponent, GameComponent, MgWalletComponent]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/shared-module/shared.module.ts